import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../UI/form/MyButton'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../../../helpers/response/ResponseHelper'
import { useDispatch } from 'react-redux'
import { addSupplierContactAPI, editSupplierContactAPI } from '../../../../../../api/supply/supplierContactAPI'
import SupplierContactTypeSelectMain from '../../../../../form/fields/SupplierContactTypeSelectMain'
import NameFieldMain from '../../../../../form/fields/NameFieldMain'
import TextFieldMain from '../../../../../form/fields/TextFieldMain'
import TextareaFieldMain from '../../../../../form/fields/TextareaFieldMain'
import { addSupplierContact, editSupplierContact } from '../../../../../../store/supplierSlice'

const SupplierContactForm = ({ supplierId, supplierContactBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplierContactBd ? supplierContactBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addSupplierContactAPI(dataForBd).then(data => {
            if (data) {
                dispatch(addSupplierContact(data))
            }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        editSupplierContactAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplierContact(data))
            }
            // if (data && data.supplyOrderNew.items) {
            //     dispatch(editSupplyOrderItems(data.supplyOrderNew.items))
            // }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            supplierId,
            supplierContactTypeId: data.supplierContactTypeId,
            name: data.name,
            phone: data.phone,
            email: data.email,
            comment: data.comment,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('supplierContactTypeId', 'supplierContact') ?
				<SupplierContactTypeSelectMain
					required={formDataProductRequiredField('supplierContactTypeId', 'supplierContact')}
					setValidate={e => updateValidate(setValid, 'supplierContactTypeId', e)}
					setValueForm={e => setValueForm(setData, 'supplierContactTypeId', e)}
					forciblyValue={data && data.supplierContactTypeId ? data.supplierContactTypeId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('name', 'supplierContact') ?
				<TextFieldMain
                    label={'Імʼя'}
					required={formDataProductRequiredField('name', 'supplierContact')}
					setValidate={e => updateValidate(setValid, 'name', e)}
					setValueForm={e => setValueForm(setData, 'name', e)}
					forciblyValue={data && data.name ? data.name : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('phone', 'supplierContact') ?
				<TextFieldMain
                    label={'Телефон'}
					required={formDataProductRequiredField('phone', 'supplierContact')}
					setValidate={e => updateValidate(setValid, 'phone', e)}
					setValueForm={e => setValueForm(setData, 'phone', e)}
					forciblyValue={data && data.phone ? data.phone : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('email', 'supplierContact') ?
				<TextFieldMain
                    label={'Email'}
					required={formDataProductRequiredField('email', 'supplierContact')}
					setValidate={e => updateValidate(setValid, 'email', e)}
					setValueForm={e => setValueForm(setData, 'email', e)}
					forciblyValue={data && data.email ? data.email : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('comment', 'supplierContact') ?
				<TextareaFieldMain
                    label={'Коментар'}
                    rows={4}
					required={formDataProductRequiredField('comment', 'supplierContact')}
					setValidate={e => updateValidate(setValid, 'comment', e)}
					setValueForm={e => setValueForm(setData, 'comment', e)}
					forciblyValue={data && data.comment ? data.comment : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplierContactForm